export default (props, vars) =>
  props?.['students'].find(
    ({ user_id }) =>
      user_id === vars?.['usestatepresentationpopupopened']?.['state']
  );
